import React from "react";

/**
 * @deprecated This icon uses Macaw-UI patterns which are deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Store } from "lucide-react";
 * // Use <Store /> instead
 */
export const MarketplaceIcon = () => (
  <svg
    width="20"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-macaw-ui-candidate
  >
    <g clipPath="url(#a)">
      <path
        d="M13.313 3.938a.937.937 0 1 1 1.874 0v1.874h1.876a.937.937 0 1 1 0 1.875h-1.875v1.875a.937.937 0 1 1-1.876 0V7.688h-1.874a.937.937 0 1 1 0-1.875h1.874V3.938Z"
        fill="currentColor"
      />
      <path
        d="M12.188 12.375c0-.104.083-.188.187-.188h4.688c.103 0 .187.084.187.188v4.688a.187.187 0 0 1-.188.187h-4.687a.187.187 0 0 1-.188-.188v-4.687ZM3.75 12.375c0-.104.084-.188.188-.188h4.687c.104 0 .188.084.188.188v4.688a.187.187 0 0 1-.188.187H3.937a.187.187 0 0 1-.187-.188v-4.687ZM3.75 3.938c0-.104.084-.188.188-.188h4.687c.104 0 .188.084.188.188v4.687a.188.188 0 0 1-.188.188H3.937a.188.188 0 0 1-.187-.188V3.937Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
